import { Capacitor } from '@capacitor/core';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeToasts } from '@sophocles/features/toast/toastActions';
import { toastSelector } from '@sophocles/features/toast/toastSelectors';

const ToastComponent = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(toastSelector);
  const { enqueueSnackbar } = useSnackbar();

  const addToast = toast => {
    const isNativePlatform = Capacitor.isNativePlatform();
    let toastMessage = toast.get('message', 'Unknown');

    if (Array.isArray(toastMessage)) {
      toastMessage = (
        <>
          {toastMessage.map((msg, index) => (
            <React.Fragment key={index}>
              {msg}
              {index !== toastMessage.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      );
    }

    const snackbarOptions = {
      variant: toast.get('level', 'default'),
      persist: false,
      anchorOrigin: isNativePlatform ? { vertical: 'bottom', horizontal: 'center' } : undefined,
      // notistack forwards unrecognized options to the custom Components renderer as props.
      title: toast.get('title'),
      dismissible: toast.get('dismissible', true),
    };

    enqueueSnackbar(toastMessage, snackbarOptions);
  };

  const handleNewToasts = toasts => {
    toasts.forEach(toast => addToast(toast));
    dispatch(removeToasts(toasts));
  };

  useEffect(() => {
    if (!toasts.isEmpty()) {
      handleNewToasts(toasts);
    }
  }, [toasts]);

  return <div id="toaster" />;
};

export default ToastComponent;
